import HeroInformation from './HeroInformation';

export default HeroInformation;
